import React from 'react';
import { useEvent } from '../../../../contexts/event-bus';
import WorkspaceItemContext from '../../../../contexts/workspace/workspace-item-context';
import { useAppDispatch } from '../../../../hooks/store-hooks';
import { useSafeEffect } from '../../../../hooks/use-safe-effect';
import { followFlight } from '../../../../state/slices/workspace-slice';
import { useFocusedWorkspaceSelector } from '../../hooks/use-view';

export default function FlightFollowMe() {
    const dispatch = useAppDispatch();
    const context = React.useContext(WorkspaceItemContext);
    const followedFlight = useFocusedWorkspaceSelector((x) => x.flights.followed);
    const focusEnabled = useFocusedWorkspaceSelector((x) => x.flights.settings.focus);

    useEvent(
        'update-end',
        React.useCallback(() => {
            if (followedFlight === null) {
                return;
            }

            const flight = context.flightLayerFacade.flights.getFlight(followedFlight);
            if (!flight) {
                // In case the flight was removed
                dispatch(followFlight(null));
                return;
            }

            // In focus mode the flight will not appear on the screen if it's not selected
            if (focusEnabled && !context.flightLayerFacade.selection.isSelected(followedFlight)) {
                return;
            }

            context.map?.easeTo({ center: flight.currentPosition as [number, number] }, { fromFollow: true });
        }, [followedFlight, focusEnabled])
    );

    useSafeEffect(() => {
        if (followedFlight === null) {
            return;
        }

        const flight = context.flightLayerFacade.flights.getFlight(followedFlight);

        if (flight) {
            context.map?.flyTo({ center: flight.currentPosition as [number, number] }, { fromFollow: true });
        } else {
            // Flight may have went away
            dispatch(followFlight(null));
        }
    }, [context.map, followedFlight]);

    return null;
}
